const r = {
  PRIMARY: "Epidemic, sans-serif"
}, _ = {
  SMALL: 22,
  // sizes in rems
  MEDIUM: 30,
  LARGE: 60
}, T = {
  /** Used for buttons and interactive elements (≤ 56px height), and inputs */
  SMALL: "2px",
  /**
   * Used for buttons and interactive elements (> 56px height),
   * and interactive images (≤ 280px height)
   * */
  MEDIUM: "4px",
  /** Used for interactive images (>280px height) */
  LARGE: "8px",
  /**
   * Used for rounded and pill shaped elements, like Badge, Icon Button and Play Button
   *
   * Note that this is a very large value (10000px) in order to achieve pill shapes, due
   * to the way browsers are meant to handle very large border-radius values. It's ugly
   * but it works.
   * */
  CIRCLE: "10000px"
}, E = {
  PRIMARY: "#009DE0",
  BLACK: "#0F0F0F",
  WHITE: "#FFF",
  PURPLE_0: "#7B61FF",
  PURPLE_1: "#8F79FF",
  COMPLEMENTARY_ORANGE: "#FF561B",
  COMPLEMENTARY_YELLOW: "#FFA800",
  COMPLEMENTARY_GREEN: "#013000",
  COMPLEMENTARY_CYAN: "#00EBDD",
  GRAY_0: "#202020",
  GRAY_1: "#2C2C2C",
  GRAY_2: "#878787",
  GRAY_3: "#E7E7E7",
  TRANSPARENT_WHITE_0: "rgba(255, 255, 255, 0.07)",
  TRANSPARENT_WHITE_1: "rgba(255, 255, 255, 0.12)",
  TRANSPARENT_WHITE_2: "rgba(255, 255, 255, 0.50)",
  TRANSPARENT_BLACK_0: "rgba(15, 15, 15, 0.05)",
  TRANSPARENT_BLACK_1: "rgba(15, 15, 15, 0.10)",
  TRANSPARENT_BLACK_2: "rgba(15, 15, 15, 0.50)",
  TRANSPARENT_OVERLAY: "rgba(0, 0, 0, 0.7)"
}, A = {
  PRIMARY: "var(--pds-color-primary, #009DE0)",
  BLACK: "var(--pds-color-black, #0F0F0F)",
  WHITE: "var(--pds-color-white, #FFF)",
  PURPLE_0: "var(--pds-color-purple_0, #7B61FF)",
  PURPLE_1: "var(--pds-color-purple_1, #8F79FF)",
  COMPLEMENTARY_ORANGE: "var(--pds-color-complementary_orange, #FF561B)",
  COMPLEMENTARY_YELLOW: "var(--pds-color-complementary_yellow, #FFA800)",
  COMPLEMENTARY_GREEN: "var(--pds-color-complementary_green, #013000)",
  COMPLEMENTARY_CYAN: "var(--pds-color-complementary_cyan, #00EBDD)",
  GRAY_0: "var(--pds-color-gray_0, #202020)",
  GRAY_1: "var(--pds-color-gray_1, #2C2C2C)",
  GRAY_2: "var(--pds-color-gray_2, #878787)",
  GRAY_3: "var(--pds-color-gray_3, #E7E7E7)",
  TRANSPARENT_WHITE_0: "var(--pds-color-transparent_white_0, rgba(255, 255, 255, 0.07))",
  TRANSPARENT_WHITE_1: "var(--pds-color-transparent_white_1, rgba(255, 255, 255, 0.12))",
  TRANSPARENT_WHITE_2: "var(--pds-color-transparent_white_2, rgba(255, 255, 255, 0.50))",
  TRANSPARENT_BLACK_0: "var(--pds-color-transparent_black_0, rgba(15, 15, 15, 0.05))",
  TRANSPARENT_BLACK_1: "var(--pds-color-transparent_black_1, rgba(15, 15, 15, 0.10))",
  TRANSPARENT_BLACK_2: "var(--pds-color-transparent_black_2, rgba(15, 15, 15, 0.50))",
  TRANSPARENT_OVERLAY: "var(--pds-color-transparent_overlay, rgba(0, 0, 0, 0.7))"
}, R = {
  MOVE_IN: "0.3s",
  MOVE_OUT: "0.2s",
  MOVE_IN_OUT: "0.2s"
}, o = {
  MOVE_IN: "cubic-bezier(0.215, 0.61, 0.355, 1)",
  MOVE_OUT: "cubic-bezier(0.55, 0.055, 0.675, 0.19)",
  MOVE_IN_OUT: "cubic-bezier(0.645, 0.045, 0.355, 1)"
}, a = {
  PRIMARY: "primary",
  SECONDARY: "secondary"
}, t = {
  /** Used for elements that floats above other content, like Contextual Menu, Toast and Tooltip */
  FLOATING: "0 8px 16px rgba(0, 0, 0, 0.25)",
  /** Used for sticky elements that sits at the top of the page, like Banner */
  TOP: "0 8px 16px rgba(0, 0, 0, 0.25)",
  /** Used for sticky elements that sits at the bottom of the page, like Playbar */
  BOTTOM: "0 -8px 16px rgba(0, 0, 0, 0.25)"
}, N = {
  TOP: "top",
  TOP_LEFT: "top_left",
  TOP_RIGHT: "top_right",
  BOTTOM: "bottom",
  BOTTOM_LEFT: "bottom_left",
  BOTTOM_RIGHT: "bottom_right",
  LEFT: "left",
  LEFT_TOP: "left_top",
  LEFT_BOTTOM: "left_bottom",
  RIGHT: "right",
  RIGHT_TOP: "right_top",
  RIGHT_BOTTOM: "right_bottom",
  CENTER: "center"
}, p = {
  DEFAULT: "default",
  TITLE: "title"
};
export {
  _ as BREAKPOINTS,
  A as COLORS,
  E as COLORS_RAW,
  o as EASINGS,
  t as ELEVATION,
  r as FONTS,
  N as POSITIONS,
  T as RADIUS,
  a as TAG_TYPES,
  R as TIMINGS,
  p as VERTICAL_TAB_VARIANTS
};
